import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";
import {
  FaMoneyBillWave,
  FaList,
  FaReceipt,
  FaCheckCircle,
  FaCreditCard,
  FaFileInvoice,
  FaClipboardList,
  FaFileInvoiceDollar,
  FaRegCalendarTimes,
  FaClock,
  FaExclamationCircle,
} from "react-icons/fa";
import { getFinancialData } from "../services/FinancialService";
import { CustomerContext } from "../context/customerContext";

const StatCard = ({ title, value, icon: Icon, iconColor, cardBg }) => (
  <div
    className="rounded-xl shadow-md hover:shadow-lg transition-all p-5 flex flex-col justify-between h-30 border border-gray-100"
    style={{ backgroundColor: cardBg || "white" }} // پس‌زمینه کل کارت
  >
    <div className="text-xs sm:text-sm md:text-sm xl:text-base text-gray-500 font-semibold">
      {title}
    </div>

    <div className="flex items-center justify-between mt-auto">
      <div className="text-sm sm:text-base md:text-xl font-extrabold text-blue-900">
        {value != null ? value.toLocaleString() : "-"}
      </div>
      <div
        className="p-2 sm:p-3 rounded-full"
        style={{ backgroundColor: `${iconColor}22` }}
      >
        <Icon className="text-lg sm:text-xl" style={{ color: iconColor }} />
      </div>
    </div>
  </div>
);

const ClickableCard = ({ title, icon: Icon, to, iconColor }) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => navigate(to)}
      className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all p-5 flex flex-col justify-between h-30 border border-gray-100 cursor-pointer hover:bg-blue-50"
    >
      <div className="text-xs sm:text-sm md:text-sm xl:text-base text-gray-500 font-semibold">
        {title}
      </div>

      <div className="flex items-center justify-between mt-auto">
        <div className="text-xs sm:text-sm md:text-base text-blue-900 font-bold">
          مشاهده
        </div>
        <div
          className="p-2 sm:p-3 rounded-full"
          style={{ backgroundColor: `${iconColor}22` }}
        >
          <Icon className="text-lg sm:text-xl" style={{ color: iconColor }} />
        </div>
      </div>
    </div>
  );
};

const FinancialInfo = () => {
  const { customer, setCustomer } = useContext(CustomerContext);

  const navigate = useNavigate();
  //   const stats = {
  //     totalDebt: 75400000,
  //     unpaidChecksCount: 4,
  //     unpaidInvoicesCount: 2,
  //     unpaidChecksAmount: 12000000,
  //     unpaidInvoicesAmount: 63400000,
  //   };

  const [stats, setStats] = useState(null);

  //   useEffect(() => {
  //     const fetchFinancialStats = async () => {
  //       try {
  //         const customerId = 1234; // اینجا شناسه مشتری رو قرار بده (مثلاً از لوکال‌استوریج یا توکن بخون)
  //         const response = await getFinancialData(customerId);
  //         setStats(response.data);
  //       } catch (error) {
  //         console.error("خطا در دریافت اطلاعات مالی:", error);
  //       }
  //     };

  //     fetchFinancialStats();
  //   }, []);

  useEffect(() => {
    if (!customer?.customerId) return;

    const fetchFinancialStats = async () => {
      try {
        const response = await getFinancialData(customer.customerId);
        setStats(response.data);
      } catch (error) {
        console.error("خطا در دریافت اطلاعات مالی:", error);
      }
    };

    fetchFinancialStats();
  }, [customer]);

  if (!stats) {
    return (
      <DashboardLayout>
        <div className="text-center text-blue-800">
          در حال بارگذاری اطلاعات مالی...
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="flex items-center justify-between px-6 mb-4">
        <h1 className="text-base sm:text-lg md:text-xl font-bold text-blue-700">اطلاعات مالی</h1>
        <button
          onClick={() => navigate(-1)}
          className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded"
        >
          بازگشت
        </button>
      </div>
      {/* ردیف اول: فقط یک کارت "کل بدهی" */}
      <div className="w-full max-w-screen-2xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 px-4 mt-4">
        <StatCard
          title="کل بدهی"
          value={stats.totalDebt}
          icon={FaMoneyBillWave}
          iconColor="#1e40af"
          cardBg="#eef2ff"
        />
      </div>

      {/* ردیف دوم و سوم: سایر کارت‌ها */}
      <div className="w-full max-w-screen-2xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 px-4 mt-4">
        <StatCard
          title="تعداد فاکتورهای تسویه‌نشده"
          value={stats.countUnsetteledInvoice}
          icon={FaReceipt}
          iconColor="#facc15"
        />
        <StatCard
          title="بدهی فاکتورهای تسویه نشده"
          value={stats.totalRemainAmount}
          icon={FaFileInvoice}
          iconColor="#059669"
        />
        <div />
        <div />
        <StatCard
          title="تعداد چک‌های وصول‌نشده"
          value={stats.countOpenReceivableNote}
          icon={FaClipboardList}
          iconColor="#f97316"
        />
        <StatCard
          title="بدهی چک‌های وصول‌نشده"
          value={stats.totalAmount}
          icon={FaCreditCard}
          iconColor="#facc15"
        />

        <StatCard
          title="بدهی چک‌های سررسید شده"
          value={stats.countDebtMaturity}
          icon={FaExclamationCircle}
          iconColor="#dc2626"
        />
        <StatCard
          title="بدهی چک‌های سررسید نشده"
          value={stats.countDebtNotMaturity}
          icon={FaClock}
          iconColor="#f59e0b"
        />
      </div>

      <div className="w-full max-w-screen-2xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 px-4 mt-9">
        <ClickableCard
          title="لیست چک‌های وصول‌نشده"
          icon={FaRegCalendarTimes}
          to="/receivableNoteList"
          iconColor="#dc2626"
        />
        <ClickableCard
          title="لیست فاکتورهای تسویه‌نشده"
          icon={FaFileInvoiceDollar}
          to="/unSettledInvoiceList"
          iconColor="#2563eb"
        />
      </div>
    </DashboardLayout>
  );
};

export default FinancialInfo;
